import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuickQuoteCalculator from "@/components/QuickQuoteCalculator";

const QuickQuote = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Quick Quote Calculator | Rick's Black Car Service</title>
        <meta name="description" content="Get an instant quote for your luxury car service in San Antonio. Calculate your fare for airport transfers, corporate travel, and special events." />
      </Helmet>
      
      <Navbar />
      
      <main className="container mx-auto px-4 pt-24 pb-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
              Quick Quote Calculator
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Get an instant estimate for your premium black car service. 
              Simply enter your trip details and receive a detailed price breakdown.
            </p>
          </div>

          <QuickQuoteCalculator />

          <div className="mt-12 text-center space-y-4">
            <div className="bg-muted/50 rounded-lg p-6 max-w-2xl mx-auto">
              <h2 className="text-xl font-semibold mb-3 text-foreground">Pricing Details</h2>
              <div className="text-sm text-muted-foreground space-y-2 text-left">
                <p>• <strong>Austin / AUS Airport:</strong> $395 + stops + surcharge, then +20% gratuity</p>
                <p>• <strong>SAT Airport Pickup ({"<"} 15 mi):</strong> $150 flat (gratuity INCLUDED) + stops ($25 ea) + surcharge</p>
                <p>• <strong>Local Service (under 15 miles):</strong> $110 + stops + surcharge, then +20% gratuity</p>
                <p>• <strong>Distance & Time Formula (15+ miles):</strong> $50 base + $3.25/mile + $1.25/minute + stops + surcharge, then +20%</p>
                <p>• <strong>Late-Night/Early Morning Surcharge:</strong> $35.00 (9 PM - 5 AM)</p>
                <p>• <strong>Additional Stops:</strong> $25.00 each</p>
                <p>• <strong>SAT Airport Minimum:</strong> $85.00 (before gratuity, for 15+ mile trips)</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default QuickQuote;
